// extracted by mini-css-extract-plugin
module.exports = {"body":"CityItem_body__te8H6"};